import ContractIcons from '@/icons/ContractIcons'
import InvoiceIcons from '@/icons/InvoiceIcons'
import NotificationGrantedIcons from '@/icons/NotificationGrantedIcons'
import PeopleIcons from '@/icons/PeopleIcons'
import ResourcesList from '../Resources/List'
import ScopesList from '../Scopes/List'
import PermissionsList from '../Permissions/List'
import PoliciesList from '../Policies/List'

export const tabs = () => [
    {
        label: 'Resources',
        value: 'authorization.resources',
        startIcon: <PeopleIcons />,
        component: <ResourcesList />,
    },
    {
        label: 'Scopes',
        value: 'authorization.scopes',
        startIcon: <InvoiceIcons />,
        component: <ScopesList />,
    },
    {
        label: 'Permissions',
        value: 'authorization.permissions',
        startIcon: <NotificationGrantedIcons />,
        component: <PermissionsList />,
    },
    {
        label: 'Policies',
        value: 'authorization.policies',
        startIcon: <ContractIcons />,
        component: <PoliciesList />,
    },
]
